export default {
    mountBreadCrumb(node) {
        let done = false;
        let items = [];
        do {
            items.push({
                text: node.name ? node.name : node.data.text,
                disable: true,
                id: node.id,
            });
            if (!node.parent || Object.keys(node.parent).length == 0) done = true;
            node = Object.assign({}, node.parent);
        } while (!done);
        return items.reverse();
    },

}